export enum UserPhotoStatus {
  accepted = 'accepted',
  canceled = 'canceled',
  new = 'new',
  notLoaded = ''
}
